<template>
  <div>
    <private-layer>
      <template slot="box-inner">
        <div class="content">
          <div class="datetime">
            <span class="date">{{ $moment().format("YYYY-MM-DD") }}</span>
            <span class="icon"><i class="iconfont icon-wendu"></i></span>
            <span class="wd">{{ wendu }}℃</span>
            <span class="tq">{{ type }}</span>
          </div>
          <div class="detail">
            <span class="icon"><i class="iconfont icon-shidu"></i></span>
            <span class="label">湿度</span>
            <span class="sd">{{ shidu }}RH</span>
            <span class="icon"><i class="iconfont icon-fengxiang"></i></span>
            <span class="label">风向</span>
            <span class="fx">{{ fx }}</span>
          </div>
        </div>
      </template>
    </private-layer>
  </div>
</template>

<script>
import PrivateLayer from '../layer'
import { GetWeatherInfo } from '@/api/home'
import axios from 'axios'
export default {
  components: { PrivateLayer },
  data () {
    return {
      wendu: '',
      shidu: '',
      fx: '',
      type: ''
    }
  },
  created () {
    // this.initWeather()
  },
  methods: {
    initWeather () {
      const data = {
        url: 'http://t.weather.sojson.com/api/weather/city/101220101'
      }
      GetWeatherInfo(data).then(res => {
        this.wendu = res.data.wendu
        this.shidu = res.data.shidu
        this.fx = res.data.forecast[0].fx
        this.type = res.data.forecast[0].type
      })
    }
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 4px 12px 8px;
  color: #fff;
  .datetime {
    span {
      margin-right: 34px;
    }
  }
  .detail {
    padding-top: 10px;
    span {
      margin-right: 18px;
    }
  }
}
</style>